export const GET_ALL_EVENT_LIST_SUCCESS = "GET_ALL_EVENT_LIST_SUCCESS";
export const GET_ALL_EVENT_LIST_ERROR = "GET_ALL_EVENT_LIST_ERROR";